import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function LocationView() {
  const [locations, setLocations] = useState([]);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchLocations = async () => {
      const res = await fetch('/api/locations', {
        headers: { 'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json' }
      });
      if (res.ok) {
        const data = await res.json();
        setLocations(data);
      }
    };
    fetchLocations();
  }, [token]);

  return (
    <div className="location-view">
      <h2>📍 Locations</h2>
      <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead style={{ backgroundColor: '#f2f2f2' }}>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Address</th>
            <th>City</th>
            <th>Latitude</th>
            <th>Longitude</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {locations.map(loc => (
            <tr key={loc.location_id}>
              <td>{loc.location_id}</td>
              <td>{loc.location_name}</td>
              <td>{loc.address_line1} {loc.address_line2}</td>
              <td>{loc.city}</td>
              <td>{loc.latitude}</td>
              <td>{loc.longitude}</td>
              <td>
                <Link to={`/dashboard/locations/edit/${loc.location_id}`}><button>Edit</button></Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Link to="/dashboard/locations/add"><button style={{ marginTop: '10px' }}>Add Location</button></Link>
    </div>
  );
}

export default LocationView;
